import { combineReducers } from "@reduxjs/toolkit";
import { templatesReducer } from "./templates/templatesSlice.js";
import { clientsReducer } from "./clients/clientsSlice.js";
import { metadataReducer } from "./metadata/metadataSlice.js";
import { userReducer } from "./user/userSlice.js";

export const rootReducer = combineReducers({
  clients: clientsReducer,
  templates: templatesReducer,
  metadata: metadataReducer,
  user: userReducer,
});
